import * as ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfiguration from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.http.js';
import * as ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.types.js';
import * as ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getTimeSlotsConfiguration(): __PublicMethodMetaInfo<
  'GET',
  { timeSlotsConfigurationId: string },
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.GetTimeSlotsConfigurationRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.GetTimeSlotsConfigurationRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.GetTimeSlotsConfigurationResponse,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.GetTimeSlotsConfigurationResponse
> {
  const payload = {
    timeSlotsConfigurationId: ':timeSlotsConfigurationId',
  } as any;

  const getRequestOptions =
    ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfiguration.getTimeSlotsConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/time-slots-configurations/{timeSlotsConfigurationId}',
    pathParams: { timeSlotsConfigurationId: 'timeSlotsConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getTimeSlotsConfigurationByAppId(): __PublicMethodMetaInfo<
  'GET',
  { appId: string },
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.GetTimeSlotsConfigurationByAppIdRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.GetTimeSlotsConfigurationByAppIdRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.GetTimeSlotsConfigurationByAppIdResponse,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.GetTimeSlotsConfigurationByAppIdResponse
> {
  const payload = { appId: ':appId' } as any;

  const getRequestOptions =
    ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfiguration.getTimeSlotsConfigurationByAppId(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/time-slots-configurations/app/{appId}',
    pathParams: { appId: 'appId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateTimeSlotsConfiguration(): __PublicMethodMetaInfo<
  'PATCH',
  { timeSlotsConfigurationId: string },
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.UpdateTimeSlotsConfigurationRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.UpdateTimeSlotsConfigurationRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.UpdateTimeSlotsConfigurationResponse,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.UpdateTimeSlotsConfigurationResponse
> {
  const payload = {
    timeSlotsConfiguration: { id: ':timeSlotsConfigurationId' },
  } as any;

  const getRequestOptions =
    ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfiguration.updateTimeSlotsConfiguration(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/time-slots-configurations/{timeSlotsConfiguration.id}',
    pathParams: { timeSlotsConfigurationId: 'timeSlotsConfigurationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryTimeSlotsConfigurations(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.QueryTimeSlotsConfigurationsRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.QueryTimeSlotsConfigurationsRequest,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationUniversalTypes.QueryTimeSlotsConfigurationsResponse,
  ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfigurationTypes.QueryTimeSlotsConfigurationsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixBookingsTimeslotsConfigurationV1TimeSlotsConfiguration.queryTimeSlotsConfigurations(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/time-slots-configurations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  TimeSlotsConfiguration as TimeSlotsConfigurationOriginal,
  DisplayTimeZone as DisplayTimeZoneOriginal,
  BasedOn as BasedOnOriginal,
  BasedOnWithLiterals as BasedOnWithLiteralsOriginal,
  StaffSelection as StaffSelectionOriginal,
  Strategy as StrategyOriginal,
  StrategyWithLiterals as StrategyWithLiteralsOriginal,
  SplitInterval as SplitIntervalOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateTimeSlotsConfigurationRequest as CreateTimeSlotsConfigurationRequestOriginal,
  CreateTimeSlotsConfigurationResponse as CreateTimeSlotsConfigurationResponseOriginal,
  GetTimeSlotsConfigurationRequest as GetTimeSlotsConfigurationRequestOriginal,
  GetTimeSlotsConfigurationResponse as GetTimeSlotsConfigurationResponseOriginal,
  GetTimeSlotsConfigurationByAppIdRequest as GetTimeSlotsConfigurationByAppIdRequestOriginal,
  GetTimeSlotsConfigurationByAppIdResponse as GetTimeSlotsConfigurationByAppIdResponseOriginal,
  UpdateTimeSlotsConfigurationRequest as UpdateTimeSlotsConfigurationRequestOriginal,
  UpdateTimeSlotsConfigurationResponse as UpdateTimeSlotsConfigurationResponseOriginal,
  QueryTimeSlotsConfigurationsRequest as QueryTimeSlotsConfigurationsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryTimeSlotsConfigurationsResponse as QueryTimeSlotsConfigurationsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './bookings-timeslots-configuration-v1-time-slots-configuration-time-slots-configuration.types.js';
